<style scoped>
</style>

<template>
	<div class="vue-box">
		<div class="c-panel">

			<!-- 参数栏 -->
			<div class="c-title">检索参数</div>
			<el-form size="mini" :inline="true" @submit.native.prevent >
        <el-form-item style="min-width: 0px;">
        <el-button type="primary" icon="el-icon-plus" @click="add()">添加</el-button>
        </el-form-item>
        <el-form-item style="min-width: 0px;">
          <el-button type="primary" icon="el-icon-search" @click="f5()">查询</el-button>
        </el-form-item>
			</el-form>
			<!-- 数据列表 -->
			<div class="c-title">数据列表</div>
			<el-table :data="dataList" size="mini">
        <el-table-column label="老师状态" width="80px">
          <template slot-scope="s">
            <el-tag class="c-tag" effect="dark" size="mini" color="#282" v-if="s.row.status==0">正常</el-tag>
            <el-tag class="c-tag" effect="dark" size="mini" color="#f22" v-if="s.row.status==1">禁用</el-tag>
          </template>
        </el-table-column>
				<el-table-column label="名称" prop="name"  width="80px"></el-table-column>
        <el-table-column label="性别" width="60px">
          <template slot-scope="s">
            <b style="color: #000000; ">{{s.row.sex==0?'男':'女'}}</b>
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="phoneNum"  width="120px"></el-table-column>
        <el-table-column label="描述" prop="des" width="280px"></el-table-column>
        <el-table-column label="入职时间" width="150px">
          <template slot-scope="s"><span>{{sa.forDate(s.row.createTime, 2)}}</span></template>
        </el-table-column>
        <el-table-column label="绑定微信" width="150px">
          <template >
            <b style="color: #000000; ">隐藏</b>
          </template>
        </el-table-column>
				<el-table-column label="操作" width="80px">
					<template slot-scope="s">
						<el-button class="c-btn" type="primary" icon="el-icon-edit" @click="update(s.row)">修改</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 增改组件 -->
		<add-or-update ref="add-or-update"></add-or-update>

	</div>
</template>

<script>
	import addOrUpdate from './teacher-list-add.vue';
	export default {
		components: {
			addOrUpdate
		},
		data() {
			return {
				dataCount: 0,
				dataList: [],		// 数据集合
			}
		},
		methods: {
			// 刷新
			f5: function(){
        this.getCampusList();
			},
      getCampusList:function (){
        this.sa.ajax('api/psdAdmin/teacher/getAllList',
            {},
            function(res){
              if(res.code == '0'){
                this.dataList = res.data;
                this.dataCount=res.data.length;
                console.log('科目',res.data);
              }else{
                this.dataList=[];
                this.dataCount=0;
                this.sa.error(res.msg || '科目列表获取失败');
              }
            }.bind(this));
      },
			// 添加
			add: function () {
				this.$refs['add-or-update'].open(0);
			},
			// 修改
			update: function (data) {
				this.$refs['add-or-update'].open(data.id);
			},

		},
		created: function(){
			this.f5();
			// this.$notify.info({
			// 	title: '消息',
			// 	message: '本页面展示表格的常见显示方式'
			// });
		},
    filters: {

    }
	}
</script>
